module.exports = __webpack_public_path__ + "static/img/about_logo.6e1c0808.png";